import { SearchItem } from '@aipb/gulliver/catalog/model';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'cat-ui-form-query',
  templateUrl: './form-query.component.html',
  styleUrls: ['./form-query.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslocoModule, MatIconModule]
})
export class FormQueryComponent {
  @Input() searchItem: SearchItem;

  public isQueryEmpty(): boolean {
    return this.searchItem.parsedQuery.length === 0;
  }

  public isBracket(v: string): boolean {
    return v === '(' || v === ')';
  }

  public isLogicalOperator(v: string): boolean {
    return v === 'AND' || v === 'OR' || v === 'NOT';
  }
}
